import { FeatureFlag } from './feature-flag';

export class UserFeatureFlag {
	public id: number;
	public userId: string;
	public featureFlagId: number;
	public show: boolean;
	public value: boolean;

	public featureFlag: FeatureFlag;

	constructor(userFeatureFlag?: UserFeatureFlag) {
		Object.assign(this, userFeatureFlag);
		if (userFeatureFlag?.featureFlag) {
			this.featureFlag = new FeatureFlag(userFeatureFlag.featureFlag);
		}
	}
}
